export default function BrandWordmark() {
  return (
    <span
      className="whitespace-nowrap text-xl font-bold leading-none tracking-[-0.035em] sm:text-[22px]"
      style={{ fontFamily: "'Poppins', sans-serif" }}
    >
      <span className="text-brand-500">Tilki</span> Otomasyon
    </span>
  );
}
